/** Company facts. Single source of truth for anything that appears in more than one place. */
export const site = {
  name: 'NETBYTE',
  legalName: 'NETBYTE UG (haftungsbeschränkt)',
  director: 'Marcus Weitschat',
  email: 'info@netbyte.bz',
  pressEmail: 'press@netbyte.bz',
  url: 'https://netbyte.bz',
  address: {
    street: 'Fährhofstraße 12',
    postalCode: '18439',
    city: 'Stralsund',
    countryCode: 'DE',
  },
  register: { court: 'Amtsgericht Stralsund', number: 'HRB 22972' },
  contactEndpoint: {
    production: 'https://api.netbyte.bz/api/v1/contact/submit',
    development: 'http://localhost:3000/api/v1/contact/submit',
  },
};

export const nav = [
  { path: '/',         labelKey: 'nav.home' },
  { path: '/games',    labelKey: 'nav.games' },
  { path: '/lab',      labelKey: 'nav.lab' },
  { path: '/services', labelKey: 'nav.services' },
  { path: '/blog',     labelKey: 'nav.blog' },
  { path: '/contact',  labelKey: 'nav.contact' },
];

export const legalNav = [
  { path: '/imprint',          labelKey: 'nav.imprint' },
  { path: '/privacy-policy',   labelKey: 'nav.privacy' },
  { path: '/terms-of-service', labelKey: 'nav.terms' },
];

export const companyNav = [
  { path: '/press',          labelKey: 'nav.press' },
  { path: '/sustainability', labelKey: 'nav.sustainability' },
];
